// extracted by mini-css-extract-plugin
export default {"card":"page_card__Qtfpq","mantine-card":"page_mantine-card__IfLWs","link":"page_link__5u5G0","mantine-Text-root":"page_mantine-Text-root__ZVGkL"};